<script setup lang="ts">
const props = defineProps<{
    label: string
    icon: string
    colorMode: 'light' | 'dark'
}>()

const emit = defineEmits<{
    (e: 'on-open'): void
}>()
</script>

<template>
    <div
        v-motion-slide-visible-once-top
        :class="[
            `group w-full h-[336px] flex flex-col rounded-lg shadow-lg pt-8 px-6 pb-2.5 hover:shadow-xl transition-shadow duration-150 cursor-pointer`,
            { 'bg-chsc-indigo-500 text-white': colorMode === 'dark' },
            { 'bg-chsc-yellow text-chsc-indigo-500': colorMode === 'light' },
        ]"
        @click="emit('on-open')"
    >
        <div
            class="h-[130px] flex items-center justify-center [&>svg]:max-h-[125px]"
            v-html="icon"
        />
        <p class="mt-6 fs-3xl text-center font-eb-garamond">
            {{ label }}
        </p>
        <div class="flex-1 flex items-end justify-center">
            <span class="mt-2 w-10 h-10 rounded-full border border-white text-white flex items-center justify-center fs-5xl font-light group-hover:rotate-90 transition-transform duration-150 cursor-pointer">
                +
            </span>
        </div>
    </div>
</template>
